<template>
  <div class="fucSuggestPage">
    <zdy-nav title="功能建议" @back="back"></zdy-nav>
    <div class="fucSuggestContent" ref="fucSuggestContent">

      <van-cell-group style="margin-top:15px;">
        <van-cell title="功能建议">
          <template slot="label">
            <van-field
              v-model="FAQType.remark"
              type="textarea"
              rows=""
              maxlength="600"
              show-word-limit
              placeholder="请填写您的宝贵建议" />
            <cube-upload
              v-model="upFileList"
              :action="{
                target: '/api/blade-platform/serviceInfo/upload',
                data: {fileType:1}
              }"
              multiple
              :size="5"
              :max="9"
              @file-success="fileSuccess"
              @file-removed="fileRemove"
              @file-click="handleImgsClick"
              :simultaneous-uploads="1"
              @files-added="filesAdded" />
          </template>
        </van-cell>
      </van-cell-group>
    </div>
    <van-button type="info" size="large" class="bottomBtnClass" :disabled="btnLoading" @click="saveInfoBefore">提 交</van-button>
  </div>
</template>

<script>
export default {
  name: 'fucSuggestPage',
  data() {
    return {
      btnLoading: false,
      picker: '',
      faqTypeList: [],
      upFileList: [],
      imgList: [],
      selectedFAQType: '',
      FAQType: {
        typeID: '',
        remark: '',
        fileList: [],
      },
      initialIndex: 0,
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo
    },
  },
  methods: {
    fileClickFile(file) {
      console.log(file)
    },
    handleImgsClick(file) {
      let url = file.response.data[0].oUrl
      let imgIndex = 0
      for(var i in this.FAQType.fileList) {
        if (this.FAQType.fileList[i] == url) {
          imgIndex = i
        }
      }
      this.initialIndex = Number(imgIndex)
      const params = {
        $props: {
          imgs: this.FAQType.fileList,
          initialIndex: 'initialIndex', // 响应式数据的key名
          loop: false
        },
        $events: {
          change: (i) => {
            // 必须更新 initialIndex
            this.initialIndex = i
          }
        }
      }
      this.$createImagePreview({ ...params }).show()
    },
    back() {
      this.$router.replace({
        name: 'homPage'
      })
    },
    filesAdded(files) {
      let hasIgnore = false
      let typeIgnore = false
      let lengthIgnore = false
      const maxSize = 5 * 1024 * 1024 // 5M
      
      const file = files[0]

      if (this.FAQType.fileList.length >= 9) {
        file.ignore = true
        lengthIgnore = true
      }
      lengthIgnore && this.$createToast({
        type: 'warn',
        time: 1500,
        txt: '上传图片不能超过9张'
      }).show()

      console.log(file)
      if (file.size > maxSize) {
        file.ignore = true
        hasIgnore = true
      }
      if (file.type !== "image/png" && file.type !== "image/jpeg" && file.type !== "image/jpg") {
        // debugger
        file.ignore = true
        typeIgnore = true
      }
      hasIgnore && this.$createToast({
        type: 'warn',
        time: 1500,
        txt: '上传图片大小不超过5M'
      }).show()
      typeIgnore && this.$createToast({
        type: 'warn',
        time: 1500,
        txt: '上传图片格式不符合规范'
      }).show()
    },
    fileRemove(fileObj) {
      let temp = []
      this.FAQType.fileList.map(item => {
        if (item !== fileObj.response.data[0].oUrl) {
          temp.push(item)
        }
      })
      this.FAQType.fileList = temp
    },
    fileSuccess(fileObj) {
      this.FAQType.fileList.push(fileObj.response.data[0].oUrl)
    },
    saveInfoBefore() {
      if (this.FAQType.remark == '') {
        this.$createToast({
          type: 'warn',
          time: 1000,
          txt: '请填写宝贵建议'
        }).show()
      } else {
        this.saveInfo()
      }
    },
    saveInfo() {
      this.btnLoading = true
      this.$store.dispatch('saveQuestionFeedbackInfo', {
        keyId: this.userInfo.USER_ID,
        useDevice: this.userInfo.phoneType == 2 ? '安卓' : 'iOS',
        deviceType: this.userInfo.model,
        deviceVersion: this.userInfo.versionCode,
        question: this.FAQType.remark,
        images: this.FAQType.fileList.join(','),
        type: 2,
        useType: '移动app'
      }).then((res) => {
        const { result } = res.data;
        if (res.data.status === 1000) {
          const toast = this.$createToast({
            txt: '提交成功',
            time: 2000,
            type: 'success',
          });
          toast.show();
          setTimeout(() => {
            
            this.$router.go(-1)
            // this.$router.replace({
            //   name: 'homPage'
            // })
            this.btnLoading = false
          }, 2000);
        } else {
          const toast = this.$createToast({
            txt: res.data.msg,
            time: 2000,
            type: 'error',
          });
          toast.show();
        }
      })
    },
  }
}
</script>

<style lang="scss">
.fucSuggestPage {
  .fucSuggestContent {
    background-color: #F6F6F6;
    margin-top: 50px;
    height: calc(100vh - 100px);
    overflow-y: auto;
    .cube-scroll-wrapper {
      padding: 0 10px;
    }
  }
  .cube-upload {
    margin-top: 10px;
    .cube-upload-btn-def {
      width: 60px;
      height: 60px;
    }
    .cube-upload-file-def {
      width: 60px;
      height: 60px;
    }
  }
  .bottomBtnClass {
    position: fixed;
    bottom: 0;
    color: #008BFF;
    background-color: #E2EFF9;
  }
  .van-button--info {
    border: 0px solid rgb(253, 254, 255);
  }
}
</style>